import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from '../../hooks/use-toast';
import { orgApi } from '../phase567Api';
import { errorMessage } from '../errors';
import PickSelect from '../shared/PickSelect';

const blank = (v) => (v == null || String(v).trim() === '' ? null : String(v).trim());

// Ticket 202: edit a branch via PATCH /v2/org/branches/{id}. `staff` is the
// active non-external roster for the manager picker (the server re-checks it).
export default function EditBranchDialog({ branch, staff, onClose, onSaved }) {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!branch) return;
    setForm({
      name: branch.name || '', address: branch.address || '', city: branch.city || '',
      state: branch.state || '', nmls: branch.nmls || '', manager_user_id: branch.manager_user_id || '',
    });
  }, [branch]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  // Changed fields only: re-sending an unchanged manager that has since left would fail the server check.
  const next = branch ? {
    name: String(form.name || '').trim(), address: blank(form.address), city: blank(form.city),
    state: blank(form.state), nmls: blank(form.nmls), manager_user_id: blank(form.manager_user_id),
  } : {};
  const body = Object.fromEntries(Object.entries(next).filter(([k, v]) => v !== (blank(branch[k]))));
  const unchanged = Object.keys(body).length === 0;
  const save = async () => {
    setBusy(true);
    try {
      await orgApi.updateBranch(branch.branch_id, body);
      toast({ title: 'Branch saved' });
      onSaved();
    } catch (e) {
      toast({ title: 'Could not save branch', description: errorMessage(e) });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!branch} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle style={{ color: '#070B5F' }} className="font-serif">Edit branch</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Name</Label><Input value={form.name || ''} onChange={set('name')} className="mt-1" data-testid="branch-name" /></div>
          <div><Label>Address</Label><Input value={form.address || ''} onChange={set('address')} className="mt-1" data-testid="branch-address" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>City</Label><Input value={form.city || ''} onChange={set('city')} className="mt-1" data-testid="branch-city" /></div>
            <div><Label>State</Label><Input value={form.state || ''} onChange={set('state')} className="mt-1" data-testid="branch-state" /></div>
          </div>
          <div><Label>NMLS ID</Label><Input value={form.nmls || ''} onChange={set('nmls')} className="mt-1" data-testid="branch-nmls" /></div>
          <PickSelect label="Manager" value={form.manager_user_id || ''} onChange={(v) => setForm((f) => ({ ...f, manager_user_id: v }))} testId="branch-manager"
            options={[{ value: '', label: 'No manager' }, ...staff.map((m) => ({ value: m.user_id, label: m.name || m.email }))]} />
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="btn-outline">Cancel</button>
          <button onClick={save} disabled={busy || unchanged || !String(form.name || '').trim()} className="btn-gold" data-testid="branch-save">Save</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
